import React from 'react';
import {connect} from 'react-redux';
import {loadLanguage} from 'Utils/jwtUtil';
// Components
import Anchor from 'Components/common/Anchor';
import Dialog from '@material-ui/core/Dialog';
import {Grid, Radio} from '@material-ui/core';
import BasicInput from 'Components/common/BasicInput';
import BasicTextArea from 'Components/common/BasicTextArea';

// Actions
import {T} from 'Actions/translate';
// Icons
import {ArrowForward} from '@material-ui/icons';
import BasicButton from 'Components/common/BasicButton';
import util from 'Utils/commonUtil';
import copy from 'copy-to-clipboard';
import {openNotification} from 'Actions/notification';
import {
    submitAddOrderNo,
    submitWithdraw,
    submitUpdate,
    receivedGoods,
} from 'Actions/host';
import {USER_ROLE} from 'Utils/constant';

class InternalTransferOrderItem extends React.Component {
    state = {
        addOrderOpened: false,
        withdrawDialogOpened: false,
        receivedDialogOpened: false,
        expressType: 'EXPRESS',
        expressNumber: '',
        remark: '',
        type: '',
    };

    getInternalOrderTagStatus = (internalOrderStatus, tabActive) => {
        let tagObje = {};
        if (internalOrderStatus === 'DRAFT') {
            tagObje = {
                tag: true,
                'internal-order-draft': true,
            };
        } else if (internalOrderStatus === 'SHIPPED') {
            if (tabActive === 0) {
                tagObje = {
                    tag: true,
                    'internal-order-shipped': true,
                };
            } else {
                tagObje = {
                    tag: true,
                    'internal-order-not_shipped': true,
                };
            }
        } else if (internalOrderStatus === 'RECEIVED') {
            if (tabActive === 0) {
                tagObje = {
                    tag: true,
                    'internal-order-completed': true,
                };
            } else {
                tagObje = {
                    tag: true,
                    'internal-order-completed': true,
                };
            }
        } else if (internalOrderStatus === 'CANCELLED') {
            if (tabActive === 0) {
                tagObje = {
                    tag: true,
                    'internal-order-cancelled': true,
                };
            } else {
                tagObje = {
                    tag: true,
                    'internal-order-callin-cancelled': true,
                };
            }
        }
        return tagObje;
    };

    getInternalOrderStatusTestid = (internalOrderStatus, tabActive) => {
        if (internalOrderStatus === 'DRAFT') {
            return 'scc-internal-transfer-status-pending-shipment';
        }
        if (internalOrderStatus === 'SHIPPED') {
            return tabActive === 0
                ? 'scc-internal-transfer-status-shipped'
                : 'scc-internal-transfer-status-pending-receipt';
        }
        if (internalOrderStatus === 'RECEIVED') {
            return 'scc-internal-transfer-status-completed';
        }
        return '';
    };

    copyContent = (text) => {
        copy(text);
        this.props.openNotification(T('notification_copy_success'), 'success');
    };

    showAddOrder = (type) => {
        const {item} = this.props;
        if (type == 'update') {
            this.setState({
                expressType: item['expressType'],
                expressNumber: item['expressNumber'],
            });
        }

        this.setState({
            addOrderOpened: true,
            remark: item['remark'], //SCME-4079	不管是否是草稿单，都将之前的remark带过来
            type,
        });
    };

    showWithdraw = () => {
        this.setState({
            withdrawDialogOpened: true,
        });
    };

    dialogDidClose = () => {
        this.setState({
            addOrderOpened: false,
            expressNumber: '',
            remark: '',
        });
    };

    dialogDidClose2 = () => {
        this.setState({
            withdrawDialogOpened: false,
        });
    };

    closeDialog3 = () => {
        this.setState({
            receivedDialogOpened: false,
        });
    };

    handleChangeRadio = (event) => {
        this.setState({
            expressType: event.target.value,
        });
    };

    handleTrackingNumberInput = (name, value) => {
        this.setState({expressNumber: value});
    };

    handleTextArea = (name, value) => {
        this.setState({remark: value});
    };

    //add order No
    addOrderNo = (item) => {
        const {expressType, expressNumber, remark, type} = this.state;
        const params = {
            orderId: item.id,
            expressType,
            expressNumber,
            remark,
        };
        if (type == 'add') {
            this.props
                .submitAddOrderNo(params)
                .then((res) => {
                    if (res['status'] == 'success') {
                        this.props.submitSuccess();
                        this.dialogDidClose();
                        this.props.openNotification(
                            T('submitSuccess') + item.orderNumber,
                            'success',
                        );
                    }
                })
                .catch((error) => {
                    this.props.openNotification(
                        T('submitFail') + T('confirm_sku_info'),
                        'danger',
                    );
                });
        } else if (type == 'update') {
            this.props
                .submitUpdate(params)
                .then((res) => {
                    if (res['status'] == 'success') {
                        this.props.submitSuccess();
                        this.dialogDidClose();
                        this.props.openNotification(
                            T('submitSuccess') + item.orderNumber,
                            'success',
                        );
                    }
                })
                .catch((error) => {
                    this.props.openNotification(
                        T('submitFail') + T('confirm_sku_info'),
                        'danger',
                    );
                });
        }
    };

    //撤回 取消
    submitWithdraw = (item) => {
        this.props
            .submitWithdraw(item.id)
            .then((res) => {
                this.props.submitSuccess();
                if (res['status'] == 'success') {
                    this.dialogDidClose2();
                    if (item.status === 'SHIPPED') {
                        this.props.openNotification(
                            T('withdrawSuccess') + item.orderNumber,
                            'success',
                        );
                    } else {
                        this.props.openNotification(
                            T('cancelSuccess') + item.orderNumber,
                            'success',
                        );
                    }
                }
            })
            .catch((error) => {
                if (item.status === 'SHIPPED') {
                    this.props.openNotification(T('withdrawFail'), 'danger');
                } else {
                    this.props.openNotification(T('cancelFail'), 'danger');
                }
            });
    };

    //收货
    receivedGood = () => {
        this.setState({
            receivedDialogOpened: true,
        });
    };

    submitReceive = (item) => {
        this.props
            .receivedGoods(item.id)
            .then((res) => {
                this.props.submitSuccess();
                if (res['status'] == 'success') {
                    this.closeDialog3();
                    this.props.openNotification(
                        T('ReceiveSuccess') + item.orderNumber,
                        'success',
                        {testid: 'scc-internal-transfer-receive-success-message'},
                    );
                }
            })
            .catch((error) => {
                this.props.openNotification(T('ReceiveFail'), 'danger', {
                    testid: 'scc-internal-transfer-receive-error-message',
                });
            });
    };

    copyToClipBoard = (item) => {
        console.log('item================================', item);
        // const {
        //     receiverAddress,
        //     receiver,
        //     receiverTel,
        // } = this.props.internalOrderDetail;
        copy(
            `${item.receiverAddress && item.receiverAddress} ${
                item.receiver && item.receiver
            } (${item.receiverTel && item.receiverTel})`,
        );
        this.props.openNotification(T('notification_copy_success'), 'success');
    };

    render() {
        const {item, chooseItem, tabActive, localData} = this.props;
        const {
            addOrderOpened,
            expressType,
            expressNumber,
            remark,
            withdrawDialogOpened,
            receivedDialogOpened,
        } = this.state;
        const isSave = () => {
            if (expressType == 'EXPRESS' && expressNumber !== '') {
                return false;
            } else if (expressType == 'SELF' && remark !== '') {
                return false;
            }
            return true;
        };

        return (
            <>
                <Anchor onClickOfSingleTap={chooseItem}>
                    <div className="order-num text-ellipsis row clearfix" data-testid="scc-internal-transfer-order-number">
                        <label>{T('host_fone_order_number')}</label>
                        {item.orderNumber}
                        <BasicButton
                            className="copy"
                            onClickOfSingleTap={() =>
                                this.copyContent(item.orderNumber)
                            }
                            isStopPropagation={true}>
                            {T('copy')}
                        </BasicButton>
                    </div>
                    <p className="transfer-supply-center text-ellipsis row">
                        <span className="transfer-out-sp text-layout" data-testid="scc-internal-transfer-source-sc-cell">
                            <span className="transfer-sp-value">
                                {item.fromScName && item.fromScName.length > 10
                                    ? `${item['fromScName'].substring(
                                          0,
                                          10,
                                      )} ‧‧‧`
                                    : item.fromScName}
                            </span>
                            <span className="transfer-sp-icon">
                                <ArrowForward className="sp-transfer-icon" />
                            </span>
                        </span>
                        <span className="transfer-in-sp text-layout" data-testid="scc-internal-transfer-destination-sc-cell">
                            {item.toScName && item.toScName.length > 10
                                ? `${item['toScName'].substring(0, 10)} ‧‧‧`
                                : item.toScName}
                        </span>
                    </p>

                    {item.shipmentTime !== null ? (
                        <p className="text-ellipsis row" data-testid="scc-internal-transfer-shipped-at-cell">
                            <label>{T('shippment_delivery_date')}</label>
                            {item.shipmentTime}
                        </p>
                    ) : null}
                    {item.expressNumber !== null &&
                    item.expressNumber !== '' ? (
                        <p className="text-ellipsis row tracking-number-area" data-testid="scc-internal-transfer-waybill-cell">
                            <label>{T('host_tracking_number')}</label>
                            {item.expressNumber}
                            <BasicButton
                                className="copy"
                                onClickOfSingleTap={() =>
                                    this.copyContent(item.expressNumber)
                                }
                                isStopPropagation={true}>
                                {T('copy')}
                            </BasicButton>
                        </p>
                    ) : null}
                    {item.status === 'RECEIVED' &&
                    item.receivedTime !== null &&
                    item.receivedTime !== '' ? (
                        <p className="text-ellipsis row" data-testid="scc-internal-transfer-received-at-cell">
                            <label>{T('host_fone_receive_date')}</label>
                            {item.receivedTime}
                        </p>
                    ) : null}
                    {item.status === 'CANCELLED' ? (
                        <p className="text-ellipsis row">
                            <label>{T('shippment_cancel_date')}</label>
                            {item.cancelTime}
                        </p>
                    ) : null}
                    {item.remark == '' || item.remark == null ? null : (
                        <p className="transfer-remark text-ellipsis row" data-testid="scc-internal-transfer-remark-cell">
                            <label>{T('shippment_remark')}</label>
                            {item.remark}
                        </p>
                    )}

                    <div className="shipment-number row space-between align-items-center">
                        <p data-testid="scc-internal-transfer-sku-cell">{item.skus}</p>
                        <span className="number" data-testid="scc-internal-transfer-total-quantity-cell">
                            {T('shippment_total_pieces', [item.skuSize])}
                        </span>
                    </div>
                    <div className="row buttons">
                        {tabActive === 0 &&
                        localData.roleType === USER_ROLE.HOST ? (
                            <BasicButton
                                type="primary"
                                className="add-tracking-number-btn"
                                onClickOfSingleTap={() => {
                                    this.copyToClipBoard(item);
                                }}
                                isStopPropagation={true}>
                                {T('copyall_btn_label')}
                            </BasicButton>
                        ) : null}
                        {item.status === 'DRAFT' &&
                        tabActive === 0 &&
                        localData.roleType === 2 ? (
                            <BasicButton
                                type="primary"
                                className="add-tracking-number-btn"
                                testid="scc-internal-transfer-add-waybill-button"
                                onClickOfSingleTap={() => {
                                    this.showAddOrder('add');
                                }}
                                isStopPropagation={true}>
                                {T('shippment_add_tracking_number')}
                            </BasicButton>
                        ) : null}
                        {(item.status === 'SHIPPED' ||
                            item.status === 'RECEIVED') &&
                        tabActive === 0 &&
                        localData.roleType === 2 ? (
                            <BasicButton
                                type="primary"
                                className="update-tracking-number-btn"
                                onClickOfSingleTap={() => {
                                    this.showAddOrder('update');
                                }}
                                isStopPropagation={true}>
                                {T('host_update_tracking_number')}
                            </BasicButton>
                        ) : null}
                        {(item.status === 'SHIPPED' ||
                            item.status === 'DRAFT') &&
                        tabActive === 0 ? (
                            <BasicButton
                                type="primary"
                                className="internal-revert-btn"
                                onClickOfSingleTap={this.showWithdraw}
                                isStopPropagation={true}>
                                {item.status === 'DRAFT'
                                    ? T('cancel')
                                    : T('host_internal_withdrawal')}
                            </BasicButton>
                        ) : null}
                        {item.status === 'SHIPPED' &&
                        tabActive === 1 &&
                        localData.roleType === 2 ? (
                            <BasicButton
                                type="primary"
                                className="receive-order-btn"
                                testid="scc-internal-transfer-receive-button"
                                onClickOfSingleTap={this.receivedGood}
                                isStopPropagation={true}>
                                {T('host_receipt')}
                            </BasicButton>
                        ) : null}
                    </div>
                    <div
                        className={util.getClassName(
                            this.getInternalOrderTagStatus(
                                item.status,
                                tabActive,
                            ),
                        )}
                        data-testid={
                            this.getInternalOrderStatusTestid(
                                item.status,
                                tabActive,
                            ) || 'scc-internal-transfer-status-cell'
                        }></div>
                </Anchor>
                <Dialog
                    open={addOrderOpened}
                    onClose={() => this.dialogDidClose()}
                    fullWidth={true}>
                    <div className="internal-dialog" data-testid="scc-internal-transfer-shipment-modal">
                        <h4 className="lot-change-dialog-title text-center">
                            {T('shippment_add_tracking_number')}
                        </h4>
                        {addOrderOpened ? (
                            <section className="content-box abnormal-record-basicselect">
                                <Grid
                                    container
                                    spacing={0}
                                    justify={'center'}
                                    className="transfer-to-container">
                                    <Grid
                                        className="delivery-method-container"
                                        container
                                        spacing={0}
                                        justify={'space-evenly'}>
                                        <Grid
                                            className="internal-dialog-grid"
                                            item
                                            xs={3}>
                                            <span className="internal-dialog-grid-label">
                                                {T('order_delivery_method')}
                                            </span>
                                        </Grid>
                                        <Grid
                                            className="delivery-method-radio internal-dialog-grid-label"
                                            item
                                            xs={9}>
                                            <Radio
                                                checked={expressType === 'SELF'}
                                                onChange={
                                                    this.handleChangeRadio
                                                }
                                                value={'SELF'}
                                                className={
                                                    expressType === 'SELF'
                                                        ? 'radio-button checked'
                                                        : 'radio-button'
                                                }
                                            />{' '}
                                            {T(
                                                'host_internal_order_self_pick_up',
                                            )}
                                            <Radio
                                                checked={
                                                    expressType === 'EXPRESS'
                                                }
                                                onChange={
                                                    this.handleChangeRadio
                                                }
                                                value={'EXPRESS'}
                                                className={
                                                    expressType === 'EXPRESS'
                                                        ? 'radio-button checked'
                                                        : 'radio-button'
                                                }
                                            />{' '}
                                            {T('order_self_express')}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    className="internal-dialog-grid internal-dialog-grid-input">
                                    <BasicInput
                                        title={
                                            'shippment_details_shipment_number'
                                        }
                                        testid="scc-internal-transfer-shipment-waybill-input"
                                        placeholder=""
                                        defalutValue={expressNumber}
                                        inputValid={
                                            this.handleTrackingNumberInput
                                        }
                                        isSearchChange={true}
                                        type="text"
                                        value={expressNumber}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <BasicTextArea
                                        type="text"
                                        title={'shippment_remark'}
                                        testid="scc-internal-transfer-shipment-remark-input"
                                        inputValid={this.handleTextArea}
                                        defalutValue={remark}
                                        value={remark}
                                    />
                                </Grid>
                            </section>
                        ) : null}
                        <Grid
                            item
                            xs={12}
                            className="internal-addOrder-submit-btn">
                            <BasicButton
                                onClickOfSingleTap={() => this.dialogDidClose()}
                                testid="scc-internal-transfer-shipment-cancel-button"
                                className="internal-addOrder-dialog-btn">
                                {T('cancel')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                testid="scc-internal-transfer-shipment-confirm-button"
                                onClickOfSingleTap={() => {
                                    this.addOrderNo(item);
                                }}
                                className="internal-addOrder-dialog-btn"
                                disabled={isSave()}>
                                {T('order_confirm')}
                            </BasicButton>
                        </Grid>
                    </div>
                </Dialog>
                <Dialog
                    open={withdrawDialogOpened}
                    onClose={this.closeDialog2}
                    fullWidth={true}>
                    <div className="confirm-popup">
                        <Grid
                            className="confirm-title-container"
                            container
                            spacing={0}>
                            <Grid className="confirm-title-grid" item xs={12}>
                                {item.status === 'SHIPPED' ? (
                                    <span>{T('transferPackage')}</span>
                                ) : (
                                    <span>{T('cancelPackage')}</span>
                                )}
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid
                                    className="confirm-revoke-label"
                                    item
                                    xs={12}>
                                    {item.status === 'SHIPPED' ? (
                                        <span>
                                            {T('confirmTransferPackage')}
                                        </span>
                                    ) : (
                                        <span>{T('confirmPackage')}</span>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid
                            className="conversion-button-container"
                            container
                            spacing={0}>
                            <Grid className="default-button-grid" item xs={12}>
                                <BasicButton
                                    disabled={false}
                                    className="confirm-conversion-btn"
                                    onClickOfSingleTap={() => {
                                        this.submitWithdraw(item);
                                    }}>
                                    <span>
                                        {T(
                                            'product_management_conversion_confirm',
                                        )}
                                    </span>
                                </BasicButton>
                                <BasicButton
                                    disabled={false}
                                    className="cancel-conversion-btn"
                                    onClickOfSingleTap={this.dialogDidClose2}>
                                    <span>{T('cancel')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
                <Dialog
                    open={receivedDialogOpened}
                    onClose={this.closeDialog3}
                    fullWidth={true}>
                    <div className="confirm-popup" data-testid="scc-internal-transfer-receive-confirm-modal">
                        <Grid
                            className="confirm-title-container"
                            container
                            spacing={0}>
                            <Grid className="confirm-title-grid" item xs={12}>
                                <span>{T('host_full_receive')}</span>
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid
                                    className="confirm-revoke-label"
                                    item
                                    xs={12}>
                                    <span>{T('host_full_ReceiveConfirm')}</span>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid
                            className="conversion-button-container"
                            container
                            spacing={0}>
                            <Grid className="default-button-grid" item xs={12}>
                                <BasicButton
                                    disabled={false}
                                    className="confirm-conversion-btn"
                                    testid="scc-internal-transfer-receive-confirm-button"
                                    onClickOfSingleTap={() => {
                                        this.submitReceive(item);
                                    }}>
                                    <span>
                                        {T(
                                            'product_management_conversion_confirm',
                                        )}
                                    </span>
                                </BasicButton>
                                <BasicButton
                                    disabled={false}
                                    className="cancel-conversion-btn"
                                    testid="scc-internal-transfer-receive-cancel-button"
                                    onClickOfSingleTap={this.closeDialog3}>
                                    <span>{T('cancel')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData} = state;
    return {
        localData,
    };
};

const mapDispatchToProps = {
    openNotification,
    submitAddOrderNo,
    submitWithdraw,
    submitUpdate,
    receivedGoods,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(InternalTransferOrderItem);
